import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';

import { getUipConfig } from '../config/uip-config';

/** Singleton */
let msal: IPublicClientApplication;

type WindowWithMsalClient = Window &
  typeof globalThis & {
    MsalClient: IPublicClientApplication;
  };

export const getMsalClient = (): IPublicClientApplication => {
  return typeof window === 'undefined' ? msal : (window as WindowWithMsalClient).MsalClient;
};

export const setMsalClient = async () => {
  if (getMsalClient()) return;

  msal = await PublicClientApplication.createPublicClientApplication(getUipConfig());
  if (typeof window === 'undefined') {
    return;
  }

  (window as WindowWithMsalClient).MsalClient = msal;
};
